import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import svTranslation from "./locales/sv.json";

i18n.use(initReactI18next).init({
  resources: {
    sv: {
      translation: svTranslation,
    },
  },
  lng: "sv", // default language
  fallbackLng: "sv",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
